import { render, staticRenderFns } from "./PlayersView.vue?vue&type=template&id=11b2b123&scoped=true"
import script from "./PlayersView.js?vue&type=script&lang=js&external"
export * from "./PlayersView.js?vue&type=script&lang=js&external"
import style0 from "./PlayersView.vue?vue&type=style&index=0&id=11b2b123&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2b123",
  null
  
)

export default component.exports